import { useState } from 'react';
import { useAppSelector, useAppDispatch } from '../../../hooks';
import { useNavigate } from 'react-router-dom';
import { resetTabsData, setActiveTab, setSubMenuActiveTab } from '../../../reducers/tabSplice';
import "./Header.css"
import { signOut } from '../../../api/auth';
import { resetUser, setToken } from '../../../reducers/UserSplice';
import Loader from '../FullscreenLoader/FullScreenLoader';
import LogoutPopup from '../MessagePopup/LogoutPopup';
import { persistor } from '../../../store/store';


const SideMenu = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState<boolean>(false);
  const [showPopup, setshowPopup] = useState<boolean>(false);

  const { activeTab, subMenuActive } = useAppSelector((state: any) => state.tabsData.tabs);
  const access_token = useAppSelector((state) => state.user.token.access_token);

  const onTabChange = (tabName: string) => {
    dispatch(setActiveTab(tabName));
    if (tabName === "challenge") {
      dispatch(setSubMenuActiveTab("check-the-rhyme"));
      navigate(`/check-the-rhyme`);
    } else {
      dispatch(setSubMenuActiveTab(""));
      navigate(`/${tabName}`);
    }
  };


  const onLogout = async () => {

    if (access_token) {

      try {
        setLoading(true)
        await signOut(access_token, {}).then(async (data) => {
          const { statusCode } = data;
          if (statusCode === 200) {
            await persistor.purge();
            await localStorage.clear();


            localStorage.removeItem('persist:root');
            await dispatch(
              setToken({
                access_token: '',
                refresh_token: ''
              }));
            navigate(`/`)
            await dispatch(resetUser());
            await dispatch(resetTabsData())
          }
        }).catch((e) => {
          console.error("error==>", e);
        });
      } catch (error: any) {

      } finally {
        setLoading(false)
      }


    }
    else {
      await persistor.purge();
      await localStorage.clear();
      await dispatch(resetUser())
      await dispatch(
        setToken({
          access_token: '',
          refresh_token: ''
        }));
      navigate(`/login`)
    }

  };

  const handleSubMenu = (event: React.MouseEvent, subMenu: string) => {
    event.stopPropagation();
    dispatch(setSubMenuActiveTab(subMenu));
    navigate(`/${subMenu}`);
  };





  const menuItems = [
    { name: "dashboard", label: "Dashboard", icon: `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}OTHER/1756905335167-0ed9c664-e6d0-4995-9106-e81f8df2a73f-dashboard-icon.png` },
    { name: "tribe", label: "Tribe", icon: `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}OTHER/1756905366317-7189f268-5647-4e34-8bb5-8f4261833766-tribe-icon.png` },
    { name: "lesson", label: "Lesson", icon: `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}OTHER/1756905394244-47a7594e-12a9-4e8d-9ad0-ea9bae702ff4-lesson-icon.png` },
    { name: "unit", label: "Unit", icon: `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}OTHER/1756905420675-a1b689e2-c912-4d20-8dd8-bfd5316ca0a0-unit-icon.png` },
    { name: "challenge", label: "Challenge", icon: `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}OTHER/1756905444518-7530388c-b8d6-4d7d-87b0-c75541dc7658-challenge-icon.png` },
  ];


  const menuItem = (item: { name: string; label: string; icon: string }) => {

    return (
      <li key={item.name} className={activeTab.includes(item.name) ? "active flex-wrap" : "flex-wrap"} style={activeTab.includes(item.name) ? { cursor: "default" } : { cursor: "pointer" }} onClick={() => onTabChange(item.name)}>
        <div className="d-flex align-items-center">
          <div className="icon me-3">
            <img src={item.icon} alt={item.label} />
          </div>
          <div className="paragraphBig">
            <span data-bs-toggle="collapse" aria-expanded="false" >
              {item.label}
            </span>
          </div>
        </div>
        <div className={`${(activeTab.includes("challenge") && item.name.includes("challenge")) ? "" : "collapse"} submenu`}>
          <ul>
            <li className={subMenuActive.includes("check-the-rhyme") ? "active" : ""} style={subMenuActive.includes("check-the-rhyme") ? { cursor: "default" } : { cursor: "pointer" }} onClick={(e) => handleSubMenu(e, "check-the-rhyme")}>Check the Rhyme</li>
            <li className={subMenuActive.includes("spelling-bee") ? "active" : ""} style={subMenuActive.includes("spelling-bee") ? { cursor: "default" } : { cursor: "pointer" }} onClick={(e) => handleSubMenu(e, "spelling-bee")}>Spelling Bee</li>
            <li style={{ cursor: "not-allowed", opacity: "30%" }}>Puzzle</li>
          </ul>
        </div>
      </li>
    );
  };


  return (
    <div>
      <div className="sideMenu">
        <ul className="menu">
          {menuItems.map(menuItem)}
        </ul>
        <div className="logout" onClick={() => setshowPopup(true)}>
          <div className="icon">
            <img src={`${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}OTHER/1756905484955-c36b1167-4640-43c3-8bb0-1f552aa3f43b-logout-icon.png`} alt="Log off" />
          </div>


          <div className="paragraphBig">Log off</div>
        </div>
      </div>
      {showPopup && (
        <LogoutPopup
          title="Are you sure you want to Logout?"
          message=""
          acceptText="Log out"
          cancelText="Cancel"
          onAccept={onLogout}
          onCancel={() => setshowPopup(false)}
        />
      )}

      {loading &&
        <Loader message="Loading, please wait..." />
      }
    </div>
  );
};

export default SideMenu;
